import axiosInstance from "./axiosInstance";

const status = async () => {
  const response = await axiosInstance.get("maintenance/status");
  return response.data;
};

const getAllMaintenance = async () => {
  const response = await axiosInstance.get("maintenance");
  return response.data;
}

const activate = async (data: { reason: string; scheduledAt?: string }) => {
  const response = await axiosInstance.post(`maintenance/activate`, data);
  return response.data;
}

const deactivate = async () => {
  const response = await axiosInstance.post(`maintenance/deactivate`);
  return response.data;
}

export const maintenanceService = {
  status,
  getAllMaintenance,
  activate,
  deactivate
};
